import * as React from 'react';
import { IconProps } from './IconProps';

const NoResultsIcon: React.FC<IconProps> = ({ size, style }) => (
  <svg width={size ?? '21'} height={size ?? '21'} viewBox="0 0 138 137" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="empty" style={style}>
    <defs>
      <linearGradient id="paint0_linear_9532_52305" x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
        <stop stopColor="white" stopOpacity="1" />
      </linearGradient>
      <linearGradient id="paint1_linear_9532_52305" x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
        <stop stopColor="#C2CECE" stopOpacity="0" />
        <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
        <stop offset="1" stopColor="#5B6A6A" stopOpacity="1" />
      </linearGradient>
      <linearGradient id="paint2_linear_9532_52305" x1="0" y1="0" x2="0" y2="1" gradientUnits="objectBoundingBox">
        <stop stopColor="#EEF0F4" stopOpacity="1" />
        <stop offset="0.927" stopColor="#E4E4E4" stopOpacity="1" />
      </linearGradient>
      <clipPath id="clip0_9532_52305">
        <rect width="137.01" height="137.01" fill="white" transform="translate(0.244141)" />
      </clipPath>
      <clipPath id="clip1_9532_52305">
        <rect width="137.01" height="137.01" fill="white" transform="translate(0.244141)" />
      </clipPath>
    </defs>
    <g id="Empty state" clipPath="url(#clip0_9532_52305)">
      <g id="Folder" clipPath="url(#clip1_9532_52305)">
        <path
          id="Vector"
          d="M123.52 25.0879H16.6428C15.2009 25.0888 13.8183 25.662 12.7987 26.6815C11.7792 27.7011 11.206 29.0837 11.2051 30.5256V128.586C11.206 130.028 11.7792 131.411 12.7987 132.43C13.8183 133.45 15.2009 134.023 16.6428 134.024H123.52C124.962 134.023 126.345 133.45 127.364 132.431C128.384 131.411 128.957 130.028 128.958 128.586V30.5256C128.957 29.0836 128.384 27.7009 127.364 26.6813C126.345 25.6618 124.962 25.0886 123.52 25.0879Z"
          fill="#C6C6C6"
        />
        <path
          id="Vector_2"
          d="M116.484 99.9484H23.6799C20.6769 99.9484 18.2422 97.5137 18.2422 94.5107V7.86887C18.2422 4.86588 20.6769 2.43115 23.6799 2.43115H116.484C119.487 2.43115 121.922 4.86588 121.922 7.86887V94.5107C121.922 97.5137 119.487 99.9484 116.484 99.9484Z"
          fill="#F9F9F9"
        />
        <path
          id="Vector_3"
          d="M19.9638 96.2318V9.59048C19.9638 6.58749 22.3985 4.15276 25.4015 4.15276H118.206C119.267 4.15276 120.253 4.46103 121.089 4.98605C120.128 3.45311 118.427 2.43115 116.484 2.43115H23.6799C20.6769 2.43115 18.2422 4.86588 18.2422 7.86887V94.5107C18.2422 96.4541 19.2641 98.1538 20.7971 99.1157C20.2721 98.2791 19.9638 97.293 19.9638 96.2323V96.2318Z"
          fill="url(#paint0_linear_9532_52305)"
        />
        <path id="Vector_4" d="M43.4375 53.5454L61.0191 71.1276H43.4375V53.5454Z" fill="url(#paint1_linear_9532_52305)" />
        <path id="Vector_5" d="M128.958 72.5781V32.1248L121.922 25.0879V72.5775H128.958V72.5781Z" fill="#C6C6C6" />
        <path
          id="Vector_6"
          d="M137.199 76.2371L129.618 129.902C129.239 132.585 126.943 134.579 124.234 134.579H15.9278C13.2185 134.579 10.9224 132.585 10.5434 129.902L0.298554 57.3875C-0.163573 54.1139 2.37672 51.189 5.68293 51.189H39.1302C41.8395 51.189 44.1355 53.1829 44.5145 55.8653L45.8571 65.3616C46.2361 68.0445 48.5322 70.0385 51.2415 70.0385H131.816C135.121 70.0385 137.662 72.9634 137.2 76.2371H137.199Z"
          fill="url(#paint2_linear_9532_52305)"
        />
        <path
          id="Vector_7"
          d="M110.339 110.642H29.8239C29.3826 110.642 28.9565 110.481 28.6254 110.189C28.2943 109.897 28.081 109.495 28.0254 109.057L27.018 101.081C26.986 100.826 27.0086 100.567 27.0844 100.321C27.1601 100.076 27.2872 99.8489 27.4573 99.6561C27.6274 99.4632 27.8365 99.3087 28.0709 99.2028C28.3052 99.097 28.5594 99.0421 28.8165 99.042H111.346C111.604 99.0421 111.858 99.097 112.092 99.2028C112.326 99.3087 112.536 99.4632 112.706 99.6561C112.876 99.8489 113.003 100.076 113.079 100.321C113.154 100.567 113.177 100.826 113.145 101.081L112.138 109.057C112.082 109.495 111.869 109.897 111.538 110.189C111.206 110.481 110.78 110.642 110.339 110.642Z"
          fill="#D5D5D5"
        />
      </g>
      <g id="Circle X">
        <path
          id="Ellipse 665"
          d="M68.7479 61.3244C81.719 61.3244 92.2341 50.8093 92.2341 37.8382C92.2341 24.8672 81.719 14.3521 68.7479 14.3521C55.7768 14.3521 45.2617 24.8672 45.2617 37.8382C45.2617 50.8093 55.7768 61.3244 68.7479 61.3244Z"
          fill="#D5D5D5"
        />
        <path
          id="Path_25936"
          d="M77.0517 48.9095L68.748 40.6059L60.4444 48.9095L57.6765 46.1416L65.9802 37.838L57.6765 29.5344L60.4444 26.7665L68.748 35.0701L77.0517 26.7665L79.8195 29.5344L71.5159 37.838L79.8195 46.1416L77.0517 48.9095Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

export default NoResultsIcon;
